import React, { useState } from "react";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { TableBase } from "../../../../components/Table/TableBase";
import {
  DetailsListLayoutMode,
  IColumn,
  ICommandBarItemProps,
  Icon,
  TooltipHost,
} from "@fluentui/react";
import { IItemListaVerificacion } from "../../../../Interfaces/IListaVerificacion";
import Estado from "../../../../components/elements/Estado";
import PersonaTag from "../../../../components/elements/Persona";
import COLORES from "../../../../utils/theme/colores";
import { useBoolean } from "@fluentui/react-hooks";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { PanelSupervisorHistorial } from "./PanelSupervisorHistorial";
import { useSupervisorHistorial } from "../../../../hooks/CheckList/useSupervisorHistorial";
import { PanelReporteTelerik } from "./PanelReporteTelerik";
import FotosCheckList from "../FotosCheckList";
import { PanelViewPdfPorChekList } from "./PanelViewPdfPorChekList";
import { TableBase2 } from "../../../../components/Table/TableBase2";
import { PaginationFooterC } from "../../../../components/PaginationFooter/PaginationFooterC";

export const SupervisorHistorial = () => {
  const _getPageSize = (value: number) => {};
  const [itemSelect, setItemSelect] = useState({ checkListId: "", nombre: "" });
  const [fotosRutas, setFotosRutas] = useState<string[]>([]);

  const {
    dataTable,
    isLoading,
    Actualizar,
    _onChangeChoiceGroup,
    _onSelectDate,
    _onkeyUpSearchTable,
    filterFechas,
    limpiarFiltor,
    onChangeComboBox,
    searchBoxRefTable,
    filter,
    onChangeSkip,
    paginacion,
  } = useSupervisorHistorial();

  const [
    isOpenPanelFotosChecklist,
    { setTrue: openPanelFotosChecklist, setFalse: dismissPanelFotosChecklist },
  ] = useBoolean(false);

  const [
    isOpenAdjunto,
    { setTrue: openPanelAdjunto, setFalse: dismissAdjunto },
  ] = useBoolean(false);

  const [
    isOpenPanelReporte,
    { setTrue: openPanelReporte, setFalse: dismissPanelReporte },
  ] = useBoolean(false);

  const [
    isOpenPanelFilter,
    { setTrue: openPanelFilter, setFalse: dismissPanelFilter },
  ] = useBoolean(false);

  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: (arg) => {
        Actualizar();
      },
    },
    // {
    //   ...IconHelper.ICON_BS_FILTER,
    //   text: "Limpiar Filtro",
    //   onClick: (arg) => {
    //     limpiarFiltor();
    //   },
    // },
  ];
  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_EXCEL,
      onClick: openPanelReporte,
    },
    {
      ...IconHelper.ICON_FILTER,
      onClick: openPanelFilter,
      text: "Buscar"
    },
  ];
  const _columns: IColumn[] = [
    {
      key: "modelo",
      name: "Modelo",
      fieldName: "modelo",
      minWidth: 150,
      maxWidth: 180,
      isResizable: true,
    },
    {
      key: "equipo",
      name: "Equipo",
      fieldName: "equipo",
      minWidth: 60,
      maxWidth: 60,
      isResizable: true,
    },
    {
      key: "fecha",
      name: "Fecha",
      fieldName: "fecha",
      minWidth: 100,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "estado",
      name: "Estado",
      fieldName: "estado",
      minWidth: 125,
      maxWidth: 130,
      isResizable: true,
      onRender: (item: IItemListaVerificacion) => (
        <Estado value={item.estado} />
      ),
    },
    {
      key: "persona",
      name: "Operador",
      fieldName: "persona",
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
      onRender: (item: IItemListaVerificacion) => (
        <PersonaTag text={item.persona} nroDoi={item.nroDOI}></PersonaTag>
      ),
    },
    {
      key: "supervisor",
      name: "Supervisor",
      fieldName: "supervisor",
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "comentario",
      name: "Comentario",
      fieldName: "comentario",
      minWidth: 90,
      maxWidth: 90,
      onRender: (item: IItemListaVerificacion) => (
        <div>
          {item.comentario != "" ? (
            <TooltipHost content={item.comentario}>
              <Icon
                iconName="CommentSolid"
                className="ms-fontSize-16"
                style={{ cursor: "pointer", color: "#bebbb8" }}
              />
            </TooltipHost>
          ) : (
            <TooltipHost content="">
              <Icon
                iconName="Comment"
                className="ms-fontSize-16"
                style={{ color: "#bebbb8" }}
              />
            </TooltipHost>
          )}
        </div>
      ),
    },
    {
      key: "observaciones",
      name: "Obs.",
      fieldName: "observaciones",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
    },
    {
      key: "observacionesCriticas",
      name: "Obs. Críticas",
      fieldName: "observacionesCriticas",
      minWidth: 80,
      maxWidth: 80,
      isResizable: true,
    },
    {
      key: "fotos",
      name: "Fotos",
      fieldName: "cantidadFotos",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
      onRender(item: IItemListaVerificacion, index?, column?) {
        if (item.cantidadFotos > 0) {
          return (
            <Icon
              iconName="PhotoCollection"
              className="ms-fontSize-16 "
              style={{
                cursor: "pointer",
                color: COLORES.Bases.neutralSecondaryAlt,
              }}
              onClick={() => {
                setFotosRutas(item.fotos);
                openPanelFotosChecklist();
              }}
            />
          );
        }
      },
    },
    {
      key: "archivo",
      name: "Archivo",
      fieldName: "listaVerificacionId",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
      onRender: (item: IItemListaVerificacion) => (
        <>
          <TooltipHost content="Ver adjunto">
            <Icon
              iconName="PDF"
              className="ms-fontSize-16 "
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => {
                setItemSelect({
                  checkListId: item.listaVerificacionId,
                  nombre: item.persona,
                });
                openPanelAdjunto();
              }}
            />
          </TooltipHost>
        </>
      ),
    },
  ];
  return (
    <div>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <CabeceraTable
            SubTitulo="Revisar Histórico de Checklist de Equipo Trabajo"
            Titulo="Historial de CheckList"
            placeholder="Buscar operador..."
            componentRef={searchBoxRefTable}
            onKeyUp={_onkeyUpSearchTable}
          />
        </div>
      </div>
      <br />
      <TableBase2
        leftBar={_items}
        rigthBar={_farItems}
        data={dataTable}
        column={_columns}
        isLoading={isLoading}
        footerPagination={
          <PaginationFooterC
            paginacion={paginacion}
            onChangePagina={(e) => {
              onChangeSkip(e);
            }}
          />
        }
      />
      {/* <TableBase2
        leftBar={_items}
        rigthBar={_farItems}
        data={dataTable}
        column={_columns}
        isLoading={isLoading}
      /> */}
      <PanelReporteTelerik
        isOpen={isOpenPanelReporte}
        onDismiss={dismissPanelReporte}
      />
      <PanelSupervisorHistorial
        fechasFilter={filterFechas}
        filter={filter}
        onChangeComboBox={onChangeComboBox}
        onSelectDate={_onSelectDate}
        limpiarFiltro={limpiarFiltor}
        onChangeChoiceGroup={_onChangeChoiceGroup}
        isOpen={isOpenPanelFilter}
        onDismiss={dismissPanelFilter}
      />
      {/* PANEL FOTOS */}
      <FotosCheckList
        ulrFostos={fotosRutas}
        isOpen={isOpenPanelFotosChecklist}
        dismiss={dismissPanelFotosChecklist}
      />
      <PanelViewPdfPorChekList
        isOpen={isOpenAdjunto}
        onDismiss={dismissAdjunto}
        info={itemSelect}
      />
    </div>
  );
};
